import axios from 'axios';
import {
    CHECK_SESSION,
    LIST_ADMIN,
    MODIFY_ADMIN,
    DELETE_ADMIN,
    FIND_ADMIN,
    UPDATE_ADMIN,
    REGISTER_ADMIN,
    LOGIN_ADMIN,
    AUTH_ADMIN,
    LOGOUT_ADMIN,
    FIND_SENSOR,
    FIND_SENSORID,
    UPDATE_SENSORID,
    FIND_USER,
    UPDATE_USER,
    REGISTER_USER,
    FIND_GATEWAY,
    UPDATE_GATEWAY,
    FIND_SETTING,
    UPDATE_SETTING,
    REGISTER_SETTING,
    FIND_DEVICE,
    UPDATE_DEVICE,
    UPDATE_STATEDEVICE,
    REGISTER_DEVICE,
    DELETE_DEVICE,
    LIST_USER,
    DELETE_USER,
    SEARCH_LIST,
    SEARCH_DEVICE,
    DEVICE_LIST,
    LOGIN_USER,
    AUTH_USER,
    LOGOUT_USER,
    MODIFY_USER,
    UPDATE_SENSOR,
    UPDATE_POWER,
    HOME_REALTIME,
    HOME_GRAPH,
    HOME_STATUS_RESET,
    HOME_GRAPH_PRINT,
    SETTING_ALERT_UPDATE,
    SETTING_TERM_UPDATE
} from "./types";

//<!--
// SEMIQUZ EMS Admin
// Check Session - isLoggedIn
export const checkSession = (dataToSubmit) => {
    const request = axios.post('/api/session/check', dataToSubmit);
    return {
      type: CHECK_SESSION,
      payload: request
    };
};
// 관리자 설정 - 관리자 리스트  Administrator List
export function listAdmin() {
    const request = axios.get('/api/admin/list')
        .then(response => response.data);

    return {
        type: LIST_ADMIN,
        payload: request
    }
}
// 관리자 설정 - 관리자 정보수정  Modify Administrator Information
export function modifyAdmin(dataToSubmit) {
    const request = axios.post('/api/admin/modify', dataToSubmit)
        .then(response => response.data);

    return {
        type: MODIFY_ADMIN,
        payload: request
    };
}
// 관리자 설정 - 관리자 정보수정  Modify Administrator Information [삭제]
export function deleteAdmin(dataToSubmit) {
    const request = axios.post('/api/admin/delete', dataToSubmit)
        .then(response => response.data);

    return {
        type: DELETE_ADMIN,
        payload: request
    };
}
// 관리자 설정 - 관리자 추가  Add Administrator
export function findAdmin(dataToSubmit) {
    const request = axios.post('/api/admin/find', dataToSubmit)
        .then(response => response.data);

    return {
        type: FIND_ADMIN,
        payload: request
    };
}
// 관리자 설정 - 관리자 추가  Add Administrator
export function updateAdmin(dataToSubmit) {
    const request = axios.post('/api/admin/update', dataToSubmit)
        .then(response => response.data)

    return {
        type: UPDATE_ADMIN,
        payload: request
    };
}
// 관리자 설정 - 관리자 추가  Add Administrator
export function registerAdmin(dataToSubmit) {
    const request = axios.post('/api/admin/register', dataToSubmit)
        .then(response => response.data);

    return {
        type: REGISTER_ADMIN,
        payload: request
    };
}
// Login - Admin
export function loginAdmin(dataToSubmit) {
    const request = axios.post('/api/admin/login', dataToSubmit)
        .then(response => response.data);

    return {
        type: LOGIN_ADMIN,
        payload: request
    };
}
// Auth - Admin
export function authAdmin() {
    const request = axios.get('/api/admin/auth')
        .then(response => response.data);

    return {
        type: AUTH_ADMIN,
        payload: request
    };
}
// Logout - Admin
// export function logoutAdmin() {
//     const request = axios.get('/api/admin/logout')
//         .then(response => response.data);

//     return {
//         type: LOGOUT_ADMIN,
//         payload: request
//     };
// }
export function logoutAdmin(dataToSubmit) {
    console.log('logoutAdmin:', dataToSubmit);
    const request = axios.post('/api/admin/logout', dataToSubmit)
        .then(response => response.data);

    return {
        type: LOGOUT_ADMIN,
        payload: request
    };
}
// 등록 관리
// 신규 등록 - 장비 및 사용자 신규 등록  New equipment and user registration [중복확인]
export function findSensor(sensorType) {
    const request = axios.post('/api/sensor/find', sensorType)
        .then(response => response.data);

    return {
        type: FIND_SENSOR,
        payload: request
    };
}
export function findSensorId(sensorType) {
    const request = axios.post('/api/sensor_id/find', sensorType)
        .then(response => response.data);

    return {
        type: FIND_SENSORID,
        payload: request
    };
}
export function updateSensorId(dataToSubmit) {
    const request = axios.post('/api/sensor_id/update', dataToSubmit)
        .then(response => response.data);

    return {
        type: UPDATE_SENSORID,
        payload: request
    };
}
// 등록 관리
// 신규 등록 - 장비 및 사용자 신규 등록  New equipment and user registration [USER]
export function findUser(dataToSubmit) {
    const request = axios.post('/api/users/find', dataToSubmit)
        .then(response => response.data);

    return {
        type: FIND_USER,
        payload: request
    };
}
export function updateUser(dataToSubmit) {
    const request = axios.post('/api/users/update', dataToSubmit)
        .then(response => response.data);

    return {
        type: UPDATE_USER,
        payload: request
    };
}
export function registerUser(dataToSubmit) {
    const request = axios.post('/api/users/register', dataToSubmit)
        .then(response => response.data);
    
    return {
        type: REGISTER_USER,
        payload: request
    };
}
export function findGateway(dataToSubmit) {
    const request = axios.post('/api/users/find/gateway', dataToSubmit)
        .then(response => response.data);

    return {
        type: FIND_GATEWAY,
        payload: request
    };
}
export function updateGateway(dataToSubmit) {
    const request = axios.post('/api/users/update/gateway', dataToSubmit)
        .then(response => response.data);

    return {
        type: UPDATE_GATEWAY,
        payload: request
    };
}
// 등록 관리
// 신규 등록 - 장비 및 사용자 신규 등록  New equipment and user registration [Setting]
export function findSetting(dataToSubmit) {
    const request = axios.post('/api/setting/find', dataToSubmit)
        .then(response => response.data);

    return {
        type: FIND_SETTING,
        payload: request
    };
}
export function updateSetting(dataToSubmit) {
    const request = axios.post('/api/setting/update', dataToSubmit)
        .then(response => response.data);

    return {
        type: UPDATE_SETTING,
        payload: request
    };
}
export function registerSetting(dataToSubmit) {
    const request = axios.post('/api/setting/register', dataToSubmit)
        .then(response => response.data);

    return {
        type: REGISTER_SETTING,
        payload: request
    };
}
// 등록 관리
// 신규 등록 - 장비 및 사용자 신규 등록  New equipment and user registration [Device]
export function findDevice(dataToSubmit) {
    const request = axios.post('/api/device/find', dataToSubmit)
        .then(response => response.data);

    return {
        type: FIND_DEVICE,
        payload: request
    };
}
export function updateDevice(dataToSubmit) {
    const request = axios.post('/api/device/update', dataToSubmit)
        .then(response => response.data);

    return {
        type: UPDATE_DEVICE,
        payload: request
    };
}
export function updateStateDevice(dataToSubmit) {
    const request = axios.post('/api/device/state/update', dataToSubmit)
        .then(response => response.data);

    return {
        type: UPDATE_STATEDEVICE,
        payload: request
    };
}
export function registerDevice(dataToSubmit) {
    const request = axios.post('/api/device/register', dataToSubmit)
        .then(response => response.data);

    return {
        type: REGISTER_DEVICE,
        payload: request
    };
}
export function deleteDevice(dataToSubmit) {
    const request = axios.post('/api/device/delete', dataToSubmit)
        .then(response => response.data);

    return {
        type: DELETE_DEVICE,
        payload: request
    };
}
// 등록 관리
// 사용자 관리 - 등록 리스트 및 관리  Registration list and management
export function listUser() {
    const request = axios.get('/api/users/list')
        .then(response => response.data);

    return {
        type: LIST_USER,
        payload: request
    };
}
export function deleteUser(dataToSubmit) {
    const request = axios.post('/api/users/delete', dataToSubmit)
        .then(response => response.data)

    return {
        type: DELETE_USER,
        payload: request
    };
}
export function searchList(dataToSubmit) {
    const request = axios.post('/api/search/list', dataToSubmit)
        .then(response => response.data)

    return {
        type: SEARCH_LIST,
        payload: request
    };
}
export function searchDevice(dataToSubmit) {
    const request = axios.post('/api/search/device', dataToSubmit)
        .then(response => response.date)

    return {
        type: SEARCH_DEVICE,
        payload: request
    }
}
// 장비 관리
// 장비 및 사용자 설정 관리  Manage equipment and user settings
export function listDevice(dataToSubmit) {
    const request = axios.post('/api/device/list', dataToSubmit)
        .then(response => response.data)

    return {
        type: DEVICE_LIST,
        payload: request
    };
}
export function modifyUser(dataToSubmit) {
    const request = axios.post('/api/users/modify', dataToSubmit)
        .then(response => response.data)

    return {
        type: MODIFY_USER,
        payload: request
    };
}
export function updateSensor(dataToSubmit) {
    const request = axios.post('/api/sensor/update', dataToSubmit)
        .then(response => response.data)

    return {
        type: UPDATE_SENSOR,
        payload: request
    };
}
export function updatePower(dataToSubmit) {
    const request = axios.post('/api/power/update', dataToSubmit)
        .then(response => response.data)

    return {
        type: UPDATE_POWER,
        payload: request
    };
}
// -->



// <!--
// User
// Auth - User
export function authUser() {
    const request = axios.get('/api/users/auth')
        .then(response => response.data);
    
    return {
        type: AUTH_USER,
        payload: request
    };
}
// Login - User
export function loginUser(dataToSubmit) {
    const request = axios.post('/api/users/login', dataToSubmit)
        .then(response => response.data);

    return {
        type: LOGIN_USER,
        payload: request
    };
}
// Logout - User
export function logoutUser() {
    const request = axios.get('/api/users/logout')
        .then(response => response.data);

    return {
        type: LOGOUT_USER,
        payload: request
    };
}
// Home - 실시간 측정치  Real Time
export function realtimeSensorData(dataToSubmit) {
    const request = axios.post('/api/home/realtime', dataToSubmit)
        .then(response => response.data)

    return {
        type: HOME_REALTIME,
        payload: request
    };
}
// Home - 측정 그래프  Measurement graph
export function getGraphData(dataToSubmit) {
    const request = axios.post('/api/home/graph', dataToSubmit)
        .then(response => response.data)

    return {
        type: HOME_GRAPH,
        payload: request
    };
}
// Home - 실시간 장비상태  Real-time Equipment status
// 재설정
export function resetDevice(dataToSubmit) {
    const request = axios.post('/api/home/status/reset', dataToSubmit)
        .then(response => response.data)

    return {
        type: HOME_STATUS_RESET,
        payload: request
    };
}
// Home - 측정이력 출력
export function printHistory(dataToSubmit) {
    const request = axios.post('/api/home/graph/print', dataToSubmit)
        .then(response => response.data)

    return {
        type: HOME_GRAPH_PRINT,
        payload: request
    };
}
// 설정 - 경고설정
export function updateAlertSetting(dataToSubmit) {
    const request = axios.post('/api/setting/alert/update', dataToSubmit)
        .then(response => response.data)

    return {
        type: SETTING_ALERT_UPDATE,
        payload: request
    };
}
// 설정 - 측정 간격 설정
export function updateTermSetting(dataToSubmit) {
    const request = axios.post('/api/setting/term/update', dataToSubmit)
        .then(response => response.data)

    return {
        type: SETTING_TERM_UPDATE,
        payload: request
    };
}
// -->
